import { InteractiveMapMTS } from "./map"; 
import { DistributionMTSTable } from "./Distribution";
import { MTSPoint, MTSDetail, Region } from "./types";
import { Button } from "antd";
import { EntMts } from "../../../models/mts"; 
import { useGetMtsByYearQuery } from "./api";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReportDepartmentMechModal from "../../../pages/admin/mechanization/reportDepartmentMech/ReportDepartmentMechModal";
import { useGetReportByMtsMutation } from "../../../redux/api/mechanization/reportDepartmentMechApi"; 


import style from './style.module.css';
import { PreloaderSvg } from "../../preloaderSvg/PreloaderSvg";
import L from "leaflet";
import { MapWithPoligons } from "../../MapWithPoligons";

export const MTS = () => {
  const { t } = useTranslation();
  const [ showReportModal, setShowReportModal ] = useState<boolean>(false);
  const [ getMtsReport ] = useGetReportByMtsMutation();
  const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());
  const [selectedItem, setSelectedItem] = useState<EntMts>(new EntMts());
  const [showModal, setShowModal] = useState<boolean>(false);

  const handleYearChange = (year: number | null) => {
    setSelectedYear(year || new Date().getFullYear());
  };

  const openAddModal = (item: EntMts) => {
    setSelectedItem(item);
    setShowModal(true);
  }




  const getReport = async (payload: { years?: number[]; languageEnum: string }): Promise<Blob> => {
    return await getMtsReport(payload).unwrap();
    };

  const { 
    data, 
    error, 
    isFetching ,
    isLoading
  } = useGetMtsByYearQuery(
    { year: selectedYear.toString() },
    {
      pollingInterval: 0,
      refetchOnFocus: true,
      refetchOnReconnect: true,
      refetchOnMountOrArgChange: true
    }
  );

  const customMarkerIcon = L.icon({
    iconUrl: '/car.svg', 
    iconSize: [35, 55],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

  const mtsPoints: MTSPoint[] = data?.res?.regions?.flatMap(region => 
    region.mtsDetails.map(detail => ({
      name: detail.name,
      managerFullName: detail.managerFullName,
      email: detail.email,
      phone: detail.phone,
      longitude: detail.longitude,
      latitude: detail.latitude,
      transportList: detail.transportList,
      totalTransport: detail.totalTransport
    }))
  ) || [];


  if (isLoading || isFetching) {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <PreloaderSvg />
        </div>
    );
}


  if (error) {
    return (
      <div className={style.container}>
        <div className={style.content}>
          <div className={style.errorMessage}>
            {error instanceof Error ? error.message : 'Ошибка при загрузке данных'}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={style.container}>
      <div className={style.content}>
      <div className={style.title}>
        <div className={style.title_header}>
                    <h1>{t('Machine and tractor stations')}</h1>
                    <Button style={{marginLeft: '5px'}} type="primary" icon={<img src="../report.svg" alt="Plus Icon" style={{ width: '16px', height: '16px' }} />} onClick={ () => setShowReportModal(true) }>
		{ t('general.generate_report') }
	  </Button>
    </div>
                    <div className={style.title_inner}>
                        <img src="./homeicon.svg" alt="home" />
                        <p>{t('Home')}</p>
                        <img src="./arrowright.svg" alt="arrow" />
                        <p>{t('Mechanization and innovations')}</p>
                        <img src="./arrowright.svg" alt="arrow" />
                        <span className={style.namepage}>{t('Machine and tractor stations')}</span>
                    </div>

 
                </div>
                <ReportDepartmentMechModal
		type={ 'mts' }
        title={ t('reports.report_by_mts') }
		getReport={ getReport }

		show={ showReportModal }
		onHide={ () => setShowReportModal(false) }
	  />
        <div style={{ position: 'relative' }}>
          <div className={style.loadingOverlay} data-visible={isFetching}>
            <div className={style.loadingMessage}>Обновление данных...</div>
          </div>
          <MapWithPoligons
                        extraData={data?.res?.regions?.flatMap(region => 
                          region.mtsDetails.map((item: MTSDetail) => ({
                            ...item,
                            popupContent: `
                                <div style="padding: 8px;">
                                    <h4 style="margin: 0 0 8px 0; color: #333; font-size: 16px;">
                                        ${item.name || 'Без названия'}
                                    </h4>
                                    <p style="margin: 4px 0; color: #666;">
                                        <strong style="color: #333;">Руководитель:</strong> ${item.managerFullName || '-'}
                                    </p>
                                    <p style="margin: 4px 0; color: #666;">
                                        <strong style="color: #333;">Email: </strong> ${item.email || '-'}
                                    </p>
                                    <p style="margin: 4px 0; color: #666;">
                                        <strong style="color: #333;">Телефон: </strong> ${item.phone || '-'}
                                    </p>
                                    <p style="margin: 4px 0; color: #666;">
                                        <strong style="color: #333;">Всего техники: </strong> ${item.totalTransport|| '-'}
                                    </p>
                                </div>
                            `
                        })))
                        }
                        latitude={41.5089324}
                        longitude={74.724091}
                        customIcon={customMarkerIcon}
                        type={["REGION"]}
                        selectedYear={selectedYear}
                        onYearChange={handleYearChange}
                    />
          <DistributionMTSTable mtsData={data?.res?.regions || []} />
        </div>
      </div>
    </div>
  );
};
  //  selectedYear={selectedYear}
  //           onYearChange={setSelectedYear}